import {BenefactorOrderStatus} from '../model';

export const getStatusBenefactorOrder = (
  status: BenefactorOrderStatus,
): {text: string; theme: 'normal' | 'info' | 'success' | 'warning' | 'danger' | 'utility' | 'unknown'} => {
  switch (status) {
    case BenefactorOrderStatus.Created:
      return {text: 'Создан', theme: 'normal'};
    case BenefactorOrderStatus.PreparedForPayment:
      return {text: 'Готов к оплате', theme: 'info'};
    case BenefactorOrderStatus.PaymentInProgress:
      return {text: 'В процессе оплаты', theme: 'info'};
    case BenefactorOrderStatus.PaymentChallenge:
      return {text: 'Ждем подтверждения', theme: 'info'};
    case BenefactorOrderStatus.PaymentChallengeResponse:
      return {text: 'Получили подтверждение', theme: 'info'};
    case BenefactorOrderStatus.PaymentFailed:
      return {text: 'Ошибка оплаты', theme: 'danger'};
    case BenefactorOrderStatus.PaymentSuccess:
      return {text: 'Оплачен', theme: 'info'};
    case BenefactorOrderStatus.Fulfilled:
      return {text: 'Исполнен', theme: 'success'};
    case BenefactorOrderStatus.Failed:
      return {text: 'Ошибка', theme: 'danger'};
    case BenefactorOrderStatus.Expired:
      return {text: 'Истёк', theme: 'normal'};
    default:
      return {text: 'Неизвестно', theme: 'unknown'};
  }
};
